/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterSentimentKind = (typeof FilterSentimentKind)[keyof typeof FilterSentimentKind];

export const FilterSentimentKind = {
  sentiment: 'sentiment',
} as const;
